export const hasMsalResponseParams = (queryOrHash: string): boolean => {
  const trimmed =
    queryOrHash.startsWith('?') || queryOrHash.startsWith('#') ? queryOrHash.slice(1) : queryOrHash;
  const params = new URLSearchParams(trimmed);

  return (
    params.has('code') ||
    params.has('error') ||
    params.has('error_description') ||
    params.has('id_token') ||
    params.has('access_token') ||
    params.has('state') ||
    params.has('client_info')
  );
};
